import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';

const iconStyle = {
  width: 48,
  height: 48,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'warning.main',
  mr: 1,
  '&:hover': {
    bgcolor: 'warning.dark',
  },
};

const LANGUAGES = [
  {
    code: 'en-US',
    name: 'English',
  },
  {
    code: 'fr-FR',
    name: 'Français',
  },
];

export default function AppFooter() {
  return (
    <Grid style={{ backgroundColor: '#12032f', bottom: 0, left: 0, right: 0, zIndex: 9999 }}>
      <Grid
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '.5px solid rgb(57, 57, 60)',
        }}
      >
        <Grid
          style={{
            flexGrow: 1,
            flexDirection: 'row',
            display: 'flex',
            padding: 25,
            maxWidth: 1200,
            paddingTop: 30,
            paddingBottom: 50,
          }}
        >
          <Grid container>
            <Grid item lg={4} xs={12} style={{ paddingBottom: 50 }}>
              <Grid>
                <Link href="/home">
                  <img src="/assets/logo.png" alt="onet logo" height={40} />
                </Link>
              </Grid>
              <Grid style={{ marginTop: 10 }}>
                <img src="/assets/bizsafelogo.png" alt="biz safe logo" height={40} />
              </Grid>
              <Grid style={{ marginTop: 10 }}>
                <img src="/assets/dpt_logo.png" alt="Data Protection Trustmark logo" height={50} />
              </Grid>
            </Grid>
            <Grid item lg={8} xs={12}>
              <Grid container>
                <Grid item lg={3} md={6} sm={6} xs={12} style={{ paddingBottom: 20 }}>
                  <Typography style={{ fontWeight: 'bold', fontSize: 14, color: 'White' }}>Overview</Typography>

                  <Link href="/event" style={{ textDecoration: 'none' }}>
                    <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 20 }}>Event</Typography>
                  </Link>

                  <Link href="/services" style={{ textDecoration: 'none' }}>
                    <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 10 }}>Services</Typography>
                  </Link>

                  <Link href="/contactus" style={{ textDecoration: 'none' }}>
                    <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 10 }}>Contact Us</Typography>
                  </Link>
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} style={{ paddingBottom: 20 }}>
                  <Typography style={{ fontWeight: 'bold', fontSize: 14, color: 'White' }}>Company</Typography>

                  <Link href="/aboutus" style={{ textDecoration: 'none' }}>
                    <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 20 }}>About Us</Typography>
                  </Link>

                  <Link href="/partners" style={{ textDecoration: 'none' }}>
                    <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 10 }}>Partners</Typography>
                  </Link>

                  <Link href="/solutions" style={{ textDecoration: 'none' }}>
                    <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 10 }}>Solutions</Typography>
                  </Link>
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} style={{ paddingBottom: 20 }}>
                  <Typography style={{ fontWeight: 'bold', fontSize: 14, color: 'White' }}>Resources</Typography>

                  <Link href="/announcement" style={{ textDecoration: 'none' }}>
                    <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 20 }}>Announcement</Typography>
                  </Link>

                  <Link href="/privacypolicy" style={{ textDecoration: 'none' }}>
                    <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 10 }}>Privacy policy</Typography>
                  </Link>

                  <Link href="/code-of-conduct" style={{ textDecoration: 'none' }}>
                    <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 10 }}>Code of Conduct</Typography>
                  </Link>
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} style={{ paddingBottom: 20 }}>
                  <Typography style={{ fontWeight: 'bold', fontSize: 14, color: 'White' }}>Need Help?</Typography>
                  <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 20 }}>+(65) 6622 5520</Typography>
                  <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 10 }}>
                    One Raffles Quay,North Tower, Level 49, SG 048583
                  </Typography>
                  <Typography style={{ fontSize: 12, color: '#af9ad3', marginTop: 10 }}>info@onet.sg</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Typography component="footer" sx={{ display: 'flex' }}>
        <Container sx={{ my: 3, display: 'flex' }}>
          <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
            <Grid item>
              <Typography variant="caption" style={{ color: '#af9ad3' }}>
                Copyright © 2025 OneT. All Rights Reserved.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Typography>
    </Grid>
  );
}
